import { Phone } from "lucide-react";
import { SITE } from "@/data/siteData";
import { HERO_IMAGES } from "@/data/siteData";

export default function CtaBanner({ title, subtitle }) {
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden bg-[#00367e] text-white">
      <img
        src={HERO_IMAGES.cleanKitchen}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#00367e] via-[#00367e]/95 to-[#066ec4]/80" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
        <div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-[1.1]">
            {title || "Besoin d'un dégraissage rapide ?"}
          </h2>
          <p className="mt-4 text-white/90 text-lg max-w-2xl">
            {subtitle || "Intervention sous 24h à Melun et en Seine-et-Marne. Devis gratuit, attestation officielle remise après chaque intervention."}
          </p>
        </div>
        <a
          href={`tel:${SITE.phoneTel}`}
          data-testid="cta-banner-call"
          className="dh-cta-shine shrink-0 inline-flex items-center justify-center gap-3 px-8 py-5 rounded-full bg-white text-[#00367e] hover:bg-slate-100 font-extrabold text-lg shadow-2xl transition-all"
        >
          <Phone size={22} strokeWidth={2.5} /> {SITE.phoneDisplay}
        </a>
      </div>
    </section>
  );
}
